import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/style.css";

function ContactPage() {
  const { t } = useTranslation();
  const phone = "+38-050-029-76-77";
  const email = "turasov1606@gmail.com";

  // Clipboard copy states
  const [copiedEmail, setCopiedEmail] = useState(false);
  const [copiedPhone, setCopiedPhone] = useState(false);

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === "email") {
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000);
    } else {
      setCopiedPhone(true);
      setTimeout(() => setCopiedPhone(false), 2000);
    }
  };

  const openContactModal = () => {
    window.dispatchEvent(new CustomEvent("open-contact-modal"));
  };

  return (
    <section id="contacts" className="section reveal">
      <div className="contacts-grid">
        
        {/* Info Column */}
        <div className="glass-card contacts-info-card">
          <h2 className="gradient-text">{t("contacts.heading")}</h2>
          <p className="contacts-subtitle" style={{ marginBottom: "28px" }}>
            {t("contacts.text")}
          </p>

          <div className="contact-method-list">
            {/* Phone Entry */}
            <div className="contact-method-item">
              <span className="contact-method-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.06-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57.15.43.03.91-.24 1.06l-2.21 2.16z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <div className="contact-method-details">
                <span className="contact-method-label">Phone</span>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", wordBreak: "break-all" }}>
                  <a href={`tel:${phone.replace(/[^+0-9]/g, "")}`} className="contact-method-value">
                    {phone}
                  </a>
                  <div className="copy-btn-container">
                    <button 
                      className="copy-clipboard-btn"
                      onClick={() => copyToClipboard(phone, "phone")}
                      title="Copy to clipboard"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                      </svg>
                    </button>
                    {copiedPhone && <span className="copy-tooltip">Copied!</span>}
                  </div>
                </div>
              </div>
            </div>

            {/* Email Entry */}
            <div className="contact-method-item">
              <span className="contact-method-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4h16v16H4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.1"/>
                  <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 6v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <div className="contact-method-details">
                <span className="contact-method-label">Email</span>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", wordBreak: "break-all" }}>
                  <a href={`mailto:${email}`} className="contact-method-value">
                    {email}
                  </a>
                  <div className="copy-btn-container">
                    <button 
                      className="copy-clipboard-btn"
                      onClick={() => copyToClipboard(email, "email")}
                      title="Copy to clipboard"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                      </svg>
                    </button>
                    {copiedEmail && <span className="copy-tooltip">Copied!</span>}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Direct CTA button to trigger message modal */}
          <button 
            className="btn btn-primary"
            onClick={openContactModal}
            style={{ display: "inline-flex", gap: "10px", marginTop: "12px", width: "100%", justifyContent: "center", padding: "14px 24px" }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            <span>{t("contacts.btn_open_modal", "Send a Message")}</span>
          </button>
        </div>

        {/* Socials Column */}
        <div className="glass-card socials-box" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div>
            <h3 style={{ fontSize: "18px", fontWeight: 700, margin: "0 0 12px 0", color: "var(--text-primary)" }}>
              {t("contacts.socialHeading")}
            </h3>
            <p style={{ color: "var(--text-muted)", fontSize: "14px", marginBottom: "24px", lineHeight: "1.6" }}>
              Connect with me across social networks or check out my repositories and coding updates.
            </p>
            
            <div className="socials-grid">
              <a href="https://github.com/DanilTop3245" target="_blank" rel="noopener noreferrer" className="social-card">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 .5A12 12 0 00.8 13.6c0 5.2 3.4 9.6 8.1 11.2.6.1.8-.3.8-.6v-2.2c-3.3.7-4-1.6-4-1.6-.5-1.2-1.3-1.6-1.3-1.6-1-.7.1-.7.1-.7 1.1.1 1.6 1.1 1.6 1.1 1.1 1.8 2.8 1.3 3.5 1 .1-.8.4-1.3.8-1.6-2.7-.3-5.6-1.4-5.6-6.3 0-1.4.5-2.5 1.2-3.4-.1-.3-.5-1.6.1-3.4 0 0 1-.3 3.4 1.2a11.7 11.7 0 016.2 0c2.4-1.5 3.4-1.2 3.4-1.2.6 1.8.2 3.1.1 3.4.7.9 1.2 2 1.2 3.4 0 4.9-2.9 6-5.7 6.3.4.4.8 1.1.8 2.2v3.2c0 .3.2.7.8.6 4.7-1.6 8.1-6 8.1-11.2A12 12 0 0012 .5z"/>
                </svg>
                <span>GitHub</span>
              </a>

              <a href="http://linkedin.com/in/danil-turasov-01b195274" target="_blank" rel="noopener noreferrer" className="social-card">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.779-1.75-1.75s.784-1.75 1.75-1.75 1.75.779 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
                <span>LinkedIn</span>
              </a>

              <a href="https://www.instagram.com/kelchik2.0/" target="_blank" rel="noopener noreferrer" className="social-card">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 7.5A4 4 0 1016 13a4 4 0 00-4-3.5zM17.5 6.5a.9.9 0 11-1.8 0 .9.9 0 011.8 0z"/>
                </svg>
                <span>Instagram</span>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61551791826265" target="_blank" rel="noopener noreferrer" className="social-card">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2.2v-2.9h2.2V9.3c0-2.2 1.3-3.4 3.3-3.4.95 0 1.95.17 1.95.17v2.1h-1.07c-1.06 0-1.39.66-1.39 1.33v1.6h2.37l-.38 2.9h-1.99v7A10 10 0 0022 12z"/>
                </svg>
                <span>Facebook</span>
              </a>
            </div>
          </div>

          <div style={{ marginTop: "24px", padding: "16px", background: "rgba(99, 102, 241, 0.04)", borderRadius: "12px", border: "1px solid rgba(99, 102, 241, 0.08)" }}>
            <span style={{ fontSize: "12px", fontWeight: 700, color: "var(--accent-1)", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              ⚡ Available for Work
            </span>
            <p style={{ fontSize: "13px", color: "var(--text-muted)", margin: "4px 0 0 0", lineHeight: "1.5" }}>
              Open for Junior Full Stack Developer opportunities & freelance web projects.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default ContactPage;
